module.exports = __webpack_public_path__ + "static/media/icon-naver.9af311a8.svg";